import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { adminAuthActions } from '../../../store/slices/adminAuth';
import { setAdminToken } from '../../../api/client';

function initials(name?: string) {
  if (!name) return 'A';
  return name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export default function AdminUserFooter() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.adminAuth?.user);
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const logout = () => {
    setAnchor(null);
    dispatch(adminAuthActions.logout());
    setAdminToken(null);
    navigate('/admin/login');
  };

  return (
    <>
      <Divider />
      <Stack direction="row" sx={{ p: 2, alignItems: 'center', gap: 1.5 }}>
        <Avatar sx={{ width: 36, height: 36, bgcolor: 'primary.main', fontSize: 14 }}>
          {initials(user?.name)}
        </Avatar>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
            {user?.name ?? 'Admin'}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {user?.email}
          </Typography>
        </Box>
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} aria-label="Account menu">
          <MoreVertRoundedIcon fontSize="small" />
        </IconButton>
      </Stack>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem onClick={logout}>Sign out</MenuItem>
      </Menu>
    </>
  );
}
